import React from 'react';

import { trans } from '@spotahome/soyuz/client';
import { Button } from '@spotahome/ui-library';

const HOME_CHECKER_APPLY_URL = 'https://spotahome897.typeform.com/to/kaHkKX';

const HomeCheckerApplyButton = () => (
  <Button
    href={HOME_CHECKER_APPLY_URL}
    color="primary"
    className="apply__button"
    target="_blank"
    size="big"
  >
    {trans('home-checker.apply.action')}
  </Button>
);

export default HomeCheckerApplyButton;
